module.exports = __webpack_public_path__ + "static/media/success-icon.430465a3.svg";